<template>
    <div>
        <h3 class="mb-3">{{ $t('teacher-details') }}</h3>

        <TextInput v-model="teacher.employer" :label="$t('employer')" />

        <TextInput v-model="teacher.job_title" :label="$t('job-title')" />
    </div>
</template>

<script>

export default {
    props: {
        value: Object,
    },
    mounted() {
        this.teacher = this.value
    },
    data() {
        return {
            teacher: {},
        }
    },
    watch: {
        teacher: {
            handler(newValue) {
                this.$emit('input', newValue)
            },
            deep: true,
        }
    },
}
</script>
